// lingland-frontend/src/i18n.js (NOWA, POPRAWIONA WERSJA)
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importujemy wszystkie nasze pliki z tłumaczeniami
import translationEN from './locales/en/translation.json';
import blogEN from './locales/en/blog.json';
import translationPL from './locales/pl/translation.json';
import blogPL from './locales/pl/blog.json';

const resources = {
  en: {
    // Definiujemy przestrzeń nazw 'translation' dla ogólnych tekstów
    translation: translationEN,
    // Definiujemy przestrzeń nazw 'blog' dla tekstów z bloga
    blog: blogEN
  },
  pl: {
    translation: translationPL,
    blog: blogPL
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'pl',
    // Definiujemy domyślną przestrzeń nazw.
    // Jeśli użyjemy t('key'), będzie szukać w 'translation'.
    // Aby użyć klucza z bloga, napiszemy t('key', { ns: 'blog' })
    defaultNS: 'translation',
    ns: ['translation', 'blog'], // Lista wszystkich przestrzeni nazw
    
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false // React jest już bezpieczny
    },
    detection: {
      order: ['cookie', 'localStorage', 'path', 'htmlTag', 'subdomain'],
      caches: ['cookie', 'localStorage'],
    }
  });

export default i18n;